import NavBar from "./navbar";
import Announcement from './announcement';
import AccessibleNavigationAnnouncer from "./accessible-navigation-announcer";

export default function Header() {
  const skipToMainContent = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    const mainContent = document.getElementById('main-content');
    if(mainContent) {
      mainContent.scrollIntoView();
      
      // different pages have different first focusable elements, find the first one
      // as of 2024-07-22, its either a button inside an accordion, or a link inside a tab list
      const focusable = mainContent.querySelectorAll('a, button');
      if(focusable && focusable.length > 0 && focusable[0] instanceof HTMLElement) {
        (focusable[0] as HTMLElement).focus();
      }
    }
  }
  
  return (
    <>
      <div role="region" aria-label="Skip to main content" id="skiptomain" tabIndex={-1}>
        <a href="#main-content" className="ontario-show-on-focus" tabIndex={0} onClick={(e) => skipToMainContent(e)}>Skip to main content</a>
      </div>
      <header>
        <AccessibleNavigationAnnouncer />
        <NavBar />
        <Announcement />
      </header>
    </>
  );
}
